import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { ImportHistoryTable } from "ui/organizms/Consumers";

const ImportHistory = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Consumers | Bulk KYC Imports'
    >
        <ImportHistoryTable />
    </Screen>
);

export default memo(ImportHistory);
